// ============================================================================
// CASE ADVOCATES HOOK — Phase 9b-2
// ============================================================================

import { useState, useEffect, useCallback } from 'react';
import { caseAdvocateService } from '../../api/services/caseAdvocateService';
import type { CaseAdvocate } from '../../api/types/caseAdvocate.types';
import type { ID } from '../../api/types';

export const useCaseAdvocates = (caseId: ID | undefined) => {
  const [data, setData] = useState<CaseAdvocate[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    if (!caseId) { setData([]); return; }
    setLoading(true); setError(null);
    try {
      const response = await caseAdvocateService.getByCase(caseId);
      setData(response.data ?? []);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [caseId]);

  useEffect(() => { fetch(); }, [fetch]);

  return { data, loading, error, refetch: fetch };
};
